import * as yup from 'yup';

export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email('Você precisa inserir um e-mail válido.')
    .required('Este campo é obrigatório.'),
});
